import { getCurrentRouteId } from 'reactApp/modules/router/router.selectors';
import { StockFolder } from 'reactApp/modules/stock/stock.type';
import { RootState } from 'reactApp/store';
import { createSelector } from 'reselect';

const getStockState = (state: RootState) => state.stock;
export const getStockList = createSelector(getStockState, (stock) => stock.list);

export const getCurrentStockFolder = createSelector(getCurrentRouteId, getStockList, (routeId, list): StockFolder | undefined => {
    const item = list[routeId];

    if (!item) {
        return;
    }

    if (item.isFolder) {
        return item;
    }

    return list[item.parent || ''] as undefined | StockFolder;
});

export const getCurrentStockIds = createSelector(getCurrentStockFolder, (folder) => folder?.childs || []);

export const getStockItemById = createSelector(
    getStockState,
    (state, id: string) => id,
    (stock, id) => stock.list[id]
);
